// @ts-strict-ignore
import React, { useContext } from 'react';
import { Badge, Text } from '@usealloy/component-library';
import {
  NOT_VALID_KEY, VALID_KEY, validityBadgeTextConfig, validityBadgeUiConfig,
} from './constants';
import { RuleEditorContext } from '../../NodeEditorDrawer/context';
import { ThresholdContext } from '../context';

const ValidityBadge = ({ isValid }: { isValid: boolean }) => {
  const { isolatedEditingBlock } = useContext(RuleEditorContext);
  const { leftDataType } = useContext(ThresholdContext);
  const validityKey = isValid ? VALID_KEY : NOT_VALID_KEY;

  const uiDetails = validityBadgeUiConfig[validityKey];
  const textDetails = validityBadgeTextConfig[isolatedEditingBlock.originType][leftDataType];
  const text = textDetails[validityKey];

  // not yet configured
  if (!text) return null;

  return (
    <Badge
      icon={uiDetails.icon}
      iconSize="small"
      style={{
        backgroundColor: uiDetails.backgroundColor,
        borderRadius: 'var(--cl-radius-3)',
        fontFamily: 'var(--cl-font-family-default)',
        marginRight: 'var(--cl-space-1)',
        padding: 'var(--cl-space-4)',
      }}
    >
      <Text size={1}>{text}</Text>
      {
        textDetails.hyperlink && (
          <a
            className="secondary"
            href={textDetails.hyperlink.link}
            target="_blank"
            rel="noreferrer"
          >
            <Text size={1} style={{ color: 'var(--cl-juicyBlue-500)' }}>
              {textDetails.hyperlink.text}
            </Text>
          </a>
        )
      }
    </Badge>
  );
};

export default ValidityBadge;
